import 'antd/dist/antd.less';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import GlobalStyle from './globalStyles';
import reportWebVitals from './reportWebVitals';
import configureStore from './state/store';
export const store = configureStore({});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
